<template>
    <div class="">
        <Header></Header>

        <!-- Main -->
        <main class="u-main">
            <Navigation></Navigation>

            <div class="u-content">
                <div class="u-body min-h-700">
                    <h1 class="h2 mb-2 text-capitalize">{{ refs }}

                        <!-- Tenants -->
                        <div class="pull-right ui-mt-15">
                            <span class="btn btn-dark btn-sm">
                                <span class="btn-icon ti-home mr-2"></span>
                                <span> {{ tenant_name }} </span>
                            </span>
                        </div>
                        <!-- End Tenants -->
                        
                    </h1>

                    <!-- Breadcrumb -->
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'dashboard' }">Home</router-link>
                            </li>
                            <li class="breadcrumb-item text-capitalize">
                                <router-link :to="{ name: refs }">{{ refs }}</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Add New</li>
                        </ol>
                    </nav>
                    <!-- End Breadcrumb -->


            <form @submit.prevent="addNew" enctype="multipart/form-data" class="h-100">

                <!-- Content -->
                <div class="tab-content">
                    <div class="row">    

                    <!-- ******* Cards ******* -->  
                    <div class="col-md-8 mb-5">

                        <!-- Card Accommodation -->
                        <div class="card">
                            <div class="card-body">
                                <div id="accordion" class="accordion">
                                    <div id="TabAccommodation" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Accommodation')"
                                            aria-expanded="false" 
                                            aria-controls="collapseAccommodation" 
                                            data-toggle="collapse"
                                            data-target="#collapseAccommodation">Accommodation
                                            <span id="iconToggleAccommodation" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    
                                    <div id="collapseAccommodation" 
                                            class="collapse show" 
                                            aria-labelledby="TabAccommodation" 
                                            data-parent="#accordion">

                                        <div class="col-12 pt-3">

                                            <!-- Name -->
                                            <div class="form-group">
                                                <label for="inputText1">Name</label>
                                                <input class="form-control"
                                                        id="inputText1"  
                                                        type="text" 
                                                        v-model="row.name">
                                            </div>
                                            <!-- Name -->

                                            <!-- Slug -->
                                            <div class="form-group">
                                                <label for="inputText2">Slug</label>
                                                <input class="form-control"
                                                        id="inputText2"  
                                                        type="text" 
                                                        v-model="row.slug">
                                            </div>
                                            <!-- Slug -->
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Card Accommodation -->


                        <!-- Card Prices -->
                        <div class="card mt-5">
                            <div class="card-body">
                                <div id="accordion" class="accordion">
                                    <div id="TabPrices" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Prices')"
                                            aria-expanded="false" 
                                            aria-controls="collapsePrices" 
                                            data-toggle="collapse"
                                            data-target="#collapsePrices">Prices
                                            <span id="iconTogglePrices" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapsePrices" 
                                        class="collapse" 
                                        aria-labelledby="TabPrices" 
                                        data-parent="#accordion">

                                        <div class="col-12 pt-3">

                                            <!-- For Loop -->
                                            <div v-for="i in row.price_key" 
                                                :key="i" 
                                                :class="(i == 0) ? 'hidden' : ''"
                                                :id="'frm_'+i"
                                                class="ui-for-div">

                                                 <!-- Remove -->
                                                <div class="pull-right ui-mt-10">
                                                    <button v-if="i != 0"
                                                        type="button" 
                                                        class="btn btn-danger btn-circle btn-with-icon btn-sm"
                                                        @click="removeOption(i)">
                                                        <span class="btn-icon ti-close font-bold"></span>
                                                     </button>
                                                </div>
                                                <!-- End Remove -->

                                                <!-- Price Name -->
                                                <div class="form-group">
                                                    <label :for="'iInput'+i">Price Name</label>
                                                    <input class="form-control" 
                                                            :id="'iInput'+i" 
                                                            type="text" 
                                                            v-model="row.price_names[i]">
                                                </div>
                                                <!-- End Price Name -->

                                                
                                                <!-- Price Items -->
                                               <div v-for="x in 10" 
                                                    :key="x" 
                                                    :class="(x != 0) ? 'hidden' : ''"
                                                    :id="'sub_'+i+'_'+x">

                                                    <div class="row col-12 ui-ml-unset">
                                                        <div class="form-group col-1"></div>
                                                        <div class="form-group col-5">
                                                            <label :for="'pvInput'+i+'_'+x">Price Value</label>
                                                            <input class="form-control" 
                                                                    :id="'pvInput'+i+'_'+x" 
                                                                    type="text" 
                                                                    v-model="row.price_item_values[i+'_'+x]">
                                                        </div>
                                                        <div class="form-group col-5">
                                                            <label :for="'pcInput'+i+'_'+x">Content</label>
                                                            <input class="form-control" 
                                                                    :id="'pcInput'+i+'_'+x" 
                                                                    type="text" 
                                                                    v-model="row.price_item_body[i+'_'+x]">
                                                        </div>
                                                        <div class="form-group col-1">
                                                            <button type="button" 
                                                                v-if="x != 0"
                                                                @click="removeSubOption(i,x)"
                                                                class="btn btn-circle btn-with-icon ui-mt30">
                                                                <span class="btn-icon ti-close font-bold"></span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- End Price Items -->

                                                <!-- Price add more -->
                                                <div class="form-group col-1">
                                                    <button type="button" 
                                                        @click="opnSub(i)"
                                                        class="btn btn-secondary btn-circle btn-with-icon ui-mt30 ui-ml-20">
                                                        <span class="btn-icon ti-plus font-bold"></span>
                                                    </button>
                                                </div>
                                                <!-- End Price add more -->
                                            </div>

                                            <!-- Add more -->
                                            <div class="row pull-right">
                                                <button type="button" 
                                                    class="btn btn-dark btn-circle btn-with-icon"
                                                    @click="opnFrm()">
                                                    <span class="btn-icon ti-plus font-bold"></span>
                                                </button>
                                            </div>
                                            <!-- End more -->

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Card Prices -->

                    </div>
                    <!-- ******* End Cards ******* -->  



                    <!-- ******* Navbar ******** -->
                    <div class="col-md-4 mb-5">
                        <!-- Nav Language -->
                        <div class="card">
                            <div class="card-body">
                                <div id="accordionNav" class="accordion">
                                    <div id="NavLanguage" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Language')" 
                                            aria-expanded="false" 
                                            aria-controls="collapseNavLanguage" 
                                            data-toggle="collapse" 
                                            data-target="#collapseNavLanguage">Language
                                            <span id="iconToggleLanguage" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseNavLanguage" 
                                        class="collapse" 
                                        aria-labelledby="NavLanguage" 
                                        data-parent="#accordionNav">
                                    
                                    <div class="col-12 pt-3">
                                        <!-- Language -->
                                        <div class="form-group">
                                            <div v-if="languageLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <select class="form-control custom-select"
                                                    v-if="!languageLoading" 
                                                    v-model="row.language_id">
                                                    <option value="">Select Language</option>
                                                    <option v-for="(language, index) in languages" 
                                                            :key="index"
                                                            :value="language.id">
                                                            {{ language.name }}
                                                    </option>
                                            </select>
                                        </div>
                                        <!-- End Language -->
                                    </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Nav Language -->

                        <!-- Nav Hotels -->
                        <div class="card mt-5">
                            <div class="card-body">
                                <div id="accordionNav" class="accordion">
                                    <div id="NavHotels" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Hotels')" 
                                            aria-expanded="false" 
                                            aria-controls="collapseNavHotels" 
                                            data-toggle="collapse" 
                                            data-target="#collapseNavHotels">Multiple Hotels
                                            <span id="iconToggleHotels" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>

                                    <div id="collapseNavHotels" 
                                        class="collapse" 
                                        aria-labelledby="NavHotels" 
                                        data-parent="#accordionNav">

                                        <div class="col-12 pt-3">
                                            <div class="form-group">
                                                <div v-if="hotelLoading" class="text-center">
                                                    <span class="spinner-grow spinner-grow-sm mr-1" 
                                                        role="status" 
                                                        aria-hidden="true">
                                                    </span>
                                                </div>
                                                <multiselect v-if="!hotelLoading"
                                                    id="multiselect"
                                                    ref="multiselectRef"
                                                    autocomplete="on"
                                                    v-model="row.hotelsValues" 
                                                    :options="hotelsOptions" 
                                                    :multiple="true"
                                                    :close-on-select="false" 
                                                    :clear-on-select="false" 
                                                    :hide-selected="true" 
                                                    :preserve-search="true" 
                                                    :taggable="false"
                                                    placeholder="Type to search hotels"
                                                    :preselect-first="false">
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Nav Hotels -->

                        <!-- Nav Status -->
                        <div class="card mt-5">
                            <div class="card-body">
                                <div id="accordionNav" class="accordion">
                                    <div id="NavStatus" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Status')"
                                            aria-expanded="false" 
                                            aria-controls="collapseNavStatus" 
                                            data-toggle="collapse"
                                            data-target="#collapseNavStatus">Status & Visibility
                                            <span id="iconToggleStatus" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseNavStatus" 
                                        class="collapse" 
                                        aria-labelledby="NavStatus" 
                                        data-parent="#accordionNav">
                                        
                                        <div class="col-12 pt-3">
                                            <!-- Status -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox" 
                                                        class="custom-control-input" 
                                                        id="customSwitch1" 
                                                        :checked="row.status"
                                                        @click="onStatus">
                                                    <label class="custom-control-label" 
                                                        for="customSwitch1"
                                                        v-html="(row.status) ? 'Active' : 'Inactive'">
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End Status -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Nav Status -->

                    </div>
                    <!-- ******* End Navbar ******** -->

                    </div>
                </div>
                <!-- End Content -->
                    
                    <!-- Button -->
                    <div class="col-md-12 row">
                        <div class="form-group mr-2">
                            <button class="btn btn-primary" :disabled="btnLoading">
                                <span v-if="btnLoading">
                                    <span class="spinner-grow spinner-grow-sm mr-1" 
                                        role="status" aria-hidden="true">
                                    </span>Loading...
                                </span>
                                <span v-if="!btnLoading" class="ti-check-box"></span>
                                <span v-if="!btnLoading"> Create Accommodation</span>
                            </button>
                        </div>

                        <div class="form-group">
                            <button type="button" class="btn btn-danger" 
                                :disabled="btnLoading" 
                                @click="cancel">
                                <span class="ti-close"></span>
                                <span> Cancel </span>
                            </button>
                        </div>
                    </div>
                    <!-- Button -->

                </form>
            </div>


                <Footer></Footer>
            </div>
        </main>
        <!-- End Main -->
        
    </div>
</template>

<script>
    import Header from '../layouts/Header.vue';
    import Navigation from '../layouts/Navigation';
    import Footer from '../layouts/Footer.vue';
    import Multiselect from 'vue-multiselect';
    import iziToast from 'izitoast';
    
    export default {
        name: 'Create',
        components: {
            Header,
            Navigation,
            Footer,
            Multiselect
        },
        data(){
            return {
                //
                auth: {
                    role: '',
                    access_token: '',
                },
                row: {
                    // row
                    name: '',
                    slug: '',

                    // prices & items
                    price_key: 0,
                    prices: [],
                    items: [],
                    item_key: [],
                    price_names: [],
                    price_item_values: [],
                    price_item_body: [],

                    // hotels
                    hotelsValues: [],

                    // status & visibility
                    status: 1,

                    //language
                    language_id:'',
                },
                hotelsOptions: [],
                hotelLoading: true,

                pgLoading: false,
                btnLoading: false,

                tenant_id: 0,
                tenant_name: '',
                refs: 'accommodations',

                // language
                languages: [],
                languageLoading: true,
            }
        },
        mounted() {},
        computed: {},
        created() {
            // AccessToken & Role
            if(localStorage.getItem('role')) {
                this.auth.role = localStorage.getItem('role');
            }
            if(localStorage.getItem('access_token')) {
                this.auth.access_token = localStorage.getItem('access_token');
            }

            // Tenants
            if(localStorage.getItem('tenant_id')) {
                this.tenant_id = localStorage.getItem('tenant_id');
            }
            if(localStorage.getItem('tenant_name')) {
                this.tenant_name = localStorage.getItem('tenant_name');
            }
            this.fetchLanguages();
        },
        methods: {

            // fetch Language
            fetchLanguages(){
                this.languageLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/languages',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.languageLoading = false;
                        this.languages = res.data.rows;
                        this.fetchHotels(); // call next func
                    })
                    .catch(() => {})
                    .finally(() => {});
            },
            // fetchHotels
            fetchHotels(){
                this.hotelLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/hotels',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.hotelLoading = false;
                        this.hotelsOptions = res.data.hotels;
                    })
                    .catch(() => {})
                    .finally(() => {});
            },


            // Add New
            addNew(){
                if(this.tenant_id == 0) {
                    
                    iziToast.warning({
                        icon: 'ti-alert',
                        title: 'Wow-man,',
                        message: 'No tenany selected.'
                    });

                } else {
                    this.btnLoading = true;
                    this.axios.defaults.headers.common = {
                        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                        'Authorization': `Bearer ` + this.auth.access_token,
                    };

                    // Multi dimension array
                    for( let i = 1; i < this.row.price_names.length; i++ ) {
                            for( let x = 1; x <= 10; x++) {
                            let item_value = this.row.price_item_values[i+'_'+x];
                            let item_body  = this.row.price_item_body[i+'_'+x];
                            if(item_value) {
                                this.row.items[x] = {
                                    'item_value' : item_value,
                                    'item_body'  : item_body
                                }
                            }
                        }
                        this.row.prices[i] = {
                            'price_name' : this.row.price_names[i],
                            'items'      : this.row.items
                        }
                        this.row.items = []; // clear array
                    }
                    
                    const config = { headers: { 'Content-Type': 'multipart/form-data' }};  
                    const options = {
                        url: window.baseURL+'/'+this.refs,
                        method: 'POST',
                        data: {
                            tenant_id: this.tenant_id,
                            // row
                            name: this.row.name,
                            slug: this.row.slug,                

                            // price & items
                            prices: this.row.prices,

                            // hotels
                            hotels: this.row.hotelsValues,

                            // status & visibility
                            status: this.row.status,

                            //language
                            language_id: this.row.language_id,
                        }
                    }
                    this.axios(options, config)
                        .then(() => {
                            this.btnLoading = false;
                            iziToast.success({
                                icon: 'ti-check',
                                title: 'Great job,',
                                message: 'Item Added Successfully.',
                            });
                            this.$router.push({ name: this.refs })
                        })
                        .catch(err => {
                            // 403 Forbidden
                            if(err.response && err.response.status == 401) {
                                this.removeLocalStorage();
                                this.$router.push({ name: 'login' });
                            } else if(err.response && err.response.status == 403) {
                                this.$router.push({ name: 'forbidden' });
                            } else {
                                this.btnLoading = false;
                                iziToast.warning({
                                    icon: 'ti-alert',
                                    title: 'Wow-man,',
                                    message: (err.response) ? err.response.data.message : ''+err
                                });
                            }
                        })
                        .finally(() => {})
                }
            },

            // add more
            opnFrm() {
                this.row.price_key++;
                this.row.item_key[this.row.price_key] = 0;
            },
            removeOption(i) {
                document.querySelector('#frm_'+i).remove()
                this.row.price_names[i] = '';
                this.row.item_key[i] = '';
                // this.row.price_key--; // makes issue

                // clear all sub
                let n = [1,2,3,4,5,6,7,8,9,10];
                n.forEach(x => {
                    this.row.price_item_values[i+'_'+x] = '';
                    this.row.price_item_body[i+'_'+x] = '';
                });
            },
            opnSub(i) {
                this.row.item_key[i] += 1;
                document.querySelector('#sub_'+i+'_'+this.row.item_key[i]).classList.remove('hidden');
            },
            removeSubOption(i,x) {
                document.querySelector('#sub_'+i+'_'+x).classList.add('hidden');
                this.row.price_item_values[i+'_'+x] = '';
                this.row.price_item_body[i+'_'+x] = '';
                this.row.item_key[i] -= 1;
            },

            // active status
            onStatus(){
                if(this.row.status)
                    this.row.status = 0;
                else
                    this.row.status = 1;
            },

            // remove sessions
            removeLocalStorage() {
                localStorage.removeItem('access_token');
                localStorage.removeItem('user_image');
                localStorage.removeItem('user_name');
                localStorage.removeItem('user_id');
                localStorage.removeItem('role');
                localStorage.removeItem('tenant_id');
            },

            // toggleCollapse
            collapseToggle(div) {
                let el = document.querySelector("span#iconToggle"+div);
                if(el.classList.contains('ti-angle-down')) {
                    el.classList.remove('ti-angle-down');
                    el.classList.add('ti-angle-up');
                } else {
                    el.classList.remove('ti-angle-up');
                    el.classList.add('ti-angle-down');
                }
            },

            // Cancel
            cancel(){
                if(confirm('Are You Sure?')) {
                    this.$router.push({ name: this.refs });
                }
            },

        },
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
